import { render, staticRenderFns } from "./Grid2.vue?vue&type=template&id=6b2e1cb2&scoped=true"
import script from "./Grid2.vue?vue&type=script&lang=ts"
export * from "./Grid2.vue?vue&type=script&lang=ts"
import style0 from "./Grid2.vue?vue&type=style&index=0&id=6b2e1cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e1cb2",
  null
  
)

export default component.exports